import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetOrganizationsToRisks = (params) =>
  axios.get(`${apiPaths.organizationsToRisksBase}`, { params: { ...params, paging: false } });

const onCreateOrganizationsToRisks = (organizationsToRisks) =>
  axios.post(apiPaths.organizationsToRisksBase, organizationsToRisks);

const onDeleteOrganizationsToRisks = (organizationToRiskIds) =>
  axios.post(`${apiPaths.organizationsToRisksBase}/delete-many`, organizationToRiskIds);

export { onGetOrganizationsToRisks, onCreateOrganizationsToRisks, onDeleteOrganizationsToRisks };
